export const decisionTypes = [
	'approved',
	'rejected',
	'rejected-major',
	'rejected-minor',
	'rejected-note',
	'not-applicable',
] as const;
